module.exports = "<div class=\"healthcareLeader\">\n  <h1>Inmar Healthcare Solutions</h1>\n  <h2>Maximize Profitability. Reduce Costs. Drive Business Intelligence.</h2>\n  <div>\n      <span>Driving profitability, risk mitigation, and operational efficiency through business intelligence and workplace solutions for pharmacies, health systems, and manufacturers.</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/landing-page/landing-page.component.html
// module id = ./src/app/components/landing-page/landing-page.component.html
// module chunks = main